import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Cropper from 'react-easy-crop';
import axiosInstance from '../api/axiosInstance';
import getCroppedImg from '../utils/cropImageHelper';
import "../styles/editProfile.css";

function ProfileUpload() {
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Upload the cropped image to the server
  const handleUpload = async () => {
    if (!imageSrc || !croppedAreaPixels) return;

    try {
      // Convert the cropped area to a blob
      const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

      // Create FormData and append the blob
      const formData = new FormData();
      formData.append('profileImage', croppedBlob, 'profile.jpg');

      // Make sure you attach the Bearer token if needed
      const token = localStorage.getItem('accessToken');
      await axiosInstance.post('/profile/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      // If success, navigate to home
      navigate('/home');
    } catch (err) {
      console.error('Upload error:', err);
      // handle error UI
    }
  };

  // Skip uploading
  const handleSkip = () => {
    navigate(-1);
  };

  return (
    <div className="profile-upload-container">
      <h2>Upload your profile picture</h2>
      {!imageSrc && (
        <div className="file-input-container">
          <label className="file-input-label">
            Choose a file
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </label>
        </div>
      )}

      {imageSrc && (
        <div className="cropper-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
      )}

      <div className="button-group">
        <button className="upload-button" onClick={handleUpload} disabled={!imageSrc}>
          Upload
        </button>
        <button className="skip-button" onClick={handleSkip}>
          Skip
        </button>
      </div>
    </div>
  );
}

export default ProfileUpload;
